<template>
    <div v-clickaway="closeContextMenu" class="referral-context-menu">
        <span class="dots" @click="toggleMenu">⋮</span>
        <referral-context-menu
            v-if="currentlyOpenContextMenu"
            :optionProp="option"
            :asContextMenu="true"
            :type="type"
            @closeReferralContextMenu="closeContextMenu"
            @emitEvent="emitEvent($event, ['closeReferralContextMenu'])"
        ></referral-context-menu>
    </div>
</template>

<script>
    import ReferralContextMenu from 'components/page-elements/ReferralContextMenu'
    import ReferralContextMenuMixin from 'mixins/ReferralContextMenuMixin'

    export default {
        mixins: [ReferralContextMenuMixin],

        components: {
            ReferralContextMenu,
        },

        props: {
            referral: { type: Object, required: true },
            type: { type: String, default: null },
            isDisabled: { type: Boolean, required: false, default: false },
        },

        computed: {
            option() {
                return {
                    value: {
                        referral: this.referral,
                    },
                }
            },
        },

        methods: {
            toggleMenu(event) {
                if (this.isDisabled) {
                    return
                }
                this.$emit('select-referral', this.referral)
                if (this.currentlyOpenContextMenu) {
                    this.closeContextMenu()
                    return
                }

                this.toggleReferralContextMenu({
                    originalEvent: event,
                    key: 'ctx-menu',
                })
            },
            closeContextMenu() {
                this.currentlyOpenContextMenu = null
            },
        },
    }
</script>
